module.exports = __webpack_public_path__ + "img/0.bd49c2a2.png";